import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { DeclarationStatus } from '@e-origin/shared';

const c = initContract();

export const DeclarationListMetadataSchema = z.object({
  total: z.number(),
  statusCounts: z.record(z.nativeEnum(DeclarationStatus), z.number()),
});

export type DeclarationListMetadata = z.infer<typeof DeclarationListMetadataSchema>;

export const declarationsListingContract = c.router({
  retrieveDeclarationGroupsMetadata: {
    method: 'GET',
    path: '/declarations/retrieve-declaration-groups-metadata',
    query: z.object({ criteria: z.string().optional() }),
    responses: {
      200: z.object({ metadata: z.any() }),
    },
  },
  retrieveDeclarationGroups: {
    method: 'GET',
    path: '/declarations/retrieve-declaration-groups',
    query: z.object({ criteria: z.string().optional() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  declarationListMetadata: {
    method: 'GET',
    path: '/declarations/declaration-list-metadata',
    query: z.object({ criteria: z.string().optional() }),
    responses: {
      200: z.object({ metadata: DeclarationListMetadataSchema }),
    },
  },
  declarationList: {
    method: 'GET',
    path: '/declarations/declaration-list',
    query: z.object({ criteria: z.string().optional() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  retrieveByStatus: {
    method: 'GET',
    path: '/declarations/retrieve-by-status/:id/:status',
    pathParams: z.object({ id: z.string(), status: z.string() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  groupedDeclarationsIds: {
    method: 'GET',
    path: '/declarations/grouped-declarations-ids',
    query: z.object({ batchId: z.string(), status: z.string().optional() }),
    responses: {
      200: z.object({ data: z.record(z.string(), z.array(z.string())) }),
    },
  },
  retrieveDeclarationByNotification: {
    method: 'GET',
    path: '/declarations/retrieve-declaration-by-notification',
    query: z.object({ batchId: z.string(), filterType: z.string() }),
    responses: {
      200: z.object({ data: z.object({ declarationId: z.string().nullable() }) }),
    },
  },
  retrieveDeclarationType: {
    method: 'GET',
    path: '/declarations/retrieve-declaration-type',
    query: z.object({ batchId: z.string() }),
    responses: {
      200: z.object({ data: z.object({ declarationType: z.any().optional(), sentTo: z.any().optional() }) }),
    },
  },
  retrieveDeclarationsRefsByImpact: {
    method: 'GET',
    path: '/declarations/:batchId/retrieve-declarations-refs-by-impact',
    pathParams: z.object({ batchId: z.string() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  getAmendmentsByLrn: {
    method: 'GET',
    path: '/declarations/:lrn/amendments',
    pathParams: z.object({ lrn: z.string() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  getDeclaration: {
    method: 'GET',
    path: '/declarations/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
});
